import React from "react";
import { ArrowUp, Github, Linkedin, Mail, FileText, Heart } from "lucide-react";
import "./Footer.css";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const yOffset = -80;
      const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <footer className="site-footer">
      <div className="container">
        
        {/* TOP FOOTER ROW */}
        <div className="footer-top-row">
          
          {/* BRAND COLUMN */}
          <div className="footer-brand-col">
            <h3 className="footer-brand-name" onClick={scrollToTop}>
              Prem Bhausaheb Gore
            </h3>
            <p className="footer-tagline">
              Software Developer specializing in Full Stack &amp; Backend Engineering (JavaScript, TypeScript, Python, Node.js). Building scalable business software &amp; AI products.
            </p>
            <div className="footer-location-tag">
              <span>📍 Shirdi, Maharashtra, India</span>
            </div>
          </div>

          {/* SITEMAP NAV COLUMN */}
          <div className="footer-nav-col">
            <h4 className="footer-heading">Navigation</h4>
            <div className="footer-links-grid">
              <button onClick={() => scrollTo("hero")}>Introduction</button>
              <button onClick={() => scrollTo("work")}>Selected Work</button>
              <button onClick={() => scrollTo("live-products")}>Live Products</button>
              <button onClick={() => scrollTo("experience")}>Experience</button>
              <button onClick={() => scrollTo("capabilities")}>Capabilities</button>
              <button onClick={() => scrollTo("technology")}>Tech Stack</button>
              <button onClick={() => scrollTo("about")}>Background</button>
              <button onClick={() => scrollTo("contact")}>Contact</button>
            </div>
          </div>

          {/* CHANNELS COLUMN */}
          <div className="footer-channels-col">
            <h4 className="footer-heading">Verified Profiles</h4>
            <div className="footer-channel-links">
              <a
                href="https://github.com/premgore"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
              >
                <Github size={16} />
                <span>GitHub Profile</span>
              </a>
              <a
                href="https://www.linkedin.com/in/prem-gore-284171417"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
              >
                <Linkedin size={16} />
                <span>LinkedIn Profile</span>
              </a>
              <a
                href="mailto:premgore063@gmail.com"
                className="footer-social-link"
              >
                <Mail size={16} />
                <span>premgore063@gmail.com</span>
              </a>
              <a
                href="/resume.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
              >
                <FileText size={16} />
                <span>View Resume (PDF)</span>
              </a>
            </div>
          </div>

        </div>

        {/* BOTTOM COPYRIGHT & BACK TO TOP */}
        <div className="footer-bottom-row">
          <div className="footer-copyright">
            © {new Date().getFullYear()} Prem Bhausaheb Gore. All rights reserved. • premgore.in
          </div>

          <button onClick={scrollToTop} className="btn-back-to-top" title="Back to top">
            <span>Back to top</span>
            <ArrowUp size={14} />
          </button>
        </div>

      </div>
    </footer>
  );
};

export default Footer;